import {loadDataSuccess, loadDataFailure, loadDataInProgress, errorMessage} from './actions';
import {tsv} from 'd3';



export const loadData = (corpus) => async (dispatch, getState) => {

    try {
        let link = ""
        if (corpus === 'petka') {
            link = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQdePlLp_u9-fWpOYiqDuoc6X6AXmzHxOSeshfOEI6TIA5MnW22Qm5lkw97BDYHNg/pub?gid=1957405706&single=true&output=tsv'
        } else if (corpus === 'punco') {
            link = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRiySna4E-2HS3g_V5j0xRTNYUmAGMJmbDuwTi2TTY01lhCa-q8Sm8u9-Nk__Hffw/pub?gid=1957405706&single=true&output=tsv'
        } else {
            link = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRiySna4E-2HS3g_V5j0xRTNYUmAGMJmbDuwTi2TTY01lhCa-q8Sm8u9-Nk__Hffw/pub?gid=1957405706&single=true&output=tsv'
        }

        dispatch(loadDataInProgress());
        // get sources
           let src = []
           const res = await  tsv(link);
       
           for (const s of res) {
               src.push(s.url)
           }
       
           const tempData = []
         // loop through sources
           for (const s of src) {
               const d = await tsv(s)
               const relevantData = d.filter(word => word["text"] !== '' && word["UD_type"] !== 'mrg'); // leave relevant data only
               let sentences = {}
               let TextName = ''
       
               // loop through raws/words
                for (const word of relevantData) {
       
                    if (word["eol"] === '0' ) {
                        TextName = word["chapter"]
                    }
       
                     if (!(word["sent_id"] in sentences)) {
                           sentences[word["sent_id"]] = []
                       }
                     const wordArray = [word["text"], word["cyrillic"],
                         word["diplomatic"], word["lemma"],
                           word["PoS_tag"], word["PoS_ext"],
                            word["sent_id"], word["UD_id"],
                         word["UD_ncy"], word["UD_type"],
                           word["UD_ext"], word["page"],
                           word["folio"], word["translation"]];
       
                           sentences[word["sent_id"]].push(wordArray);
                }
                // end loop through raws/words
               tempData.push({'text': TextName, 'sentences': sentences})
           }
           // end of loop through sources
           dispatch(loadDataSuccess(tempData))

    } catch(e) {
        dispatch(loadDataFailure())
        dispatch(errorMessage())
        console.log(e)
        alert('Error loading data.')

    }
}


